module.exports = __webpack_public_path__ + "static/media/YF17_5.0cf9e98c.jpg";